import React from 'react'
import Grid from '@material-ui/core/Grid'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.primary.main,
  },
}))

function Text({ titleText = `` }) {
  const classes = useStyles()

  return (
    <Grid
      container
      justify="center"
      alignContent="flex-start"
      alignItems="flex-start"
      className={classes.root}
    >
      {titleText}
    </Grid>
  )
}
export default Text
